import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PhotoService as ApiPhotoService, PhotosList } from '@src/api';
import { AlertService } from '@src/core/services/alert.service';
import { GetImageType } from '@src/models/images';

@Injectable({
  providedIn: 'root',
})
export class PhotoService {
  private readonly photoService = inject(ApiPhotoService);
  private readonly alertService = inject(AlertService);

  uploadPhoto(
    photo: File,
    attachId?: string,
    isCover: boolean = false,
    description?: string,
    unionId?: string,
  ): Observable<PhotosList> {
    return this.photoService.uploadFiles([photo], attachId, description, isCover, unionId).pipe(
      catchError(err => {
        this.alertService.error(err, { autoClose: 30000 });
        return throwError(() => err);
      }),
    );
  }

  uploadFiles(
    photos: File[],
    attachId?: string,
    isCover: boolean = false,
    description?: string,
    unionId?: string,
  ): Observable<PhotosList> {
    return this.photoService.uploadFiles(photos, attachId, description, isCover, unionId).pipe(
      catchError(err => {
        this.alertService.error(err, { autoClose: 30000 });
        return throwError(() => err);
      }),
    );
  }

  deletePhoto(photoId: string) {
    return this.photoService.deletePhotoById(photoId).pipe(
      catchError(err => {
        this.alertService.error(err, { autoClose: 30000 });
        return throwError(() => err);
      }),
    );
  }

  downloadPhotoById(id: string, size: GetImageType = 'thumbnail', unionId?: string) {
    switch (size) {
      case 'fullSize':
        return this.photoService.fullSizeById(id, unionId).pipe(
          catchError(err => {
            this.alertService.error(err, { autoClose: 30000 });
            return throwError(() => err);
          }),
        );

      case 'middleSize':
        return this.photoService.middleSizeById(id, unionId).pipe(
          catchError(err => {
            this.alertService.error(err, { autoClose: 30000 });
            return throwError(() => err);
          }),
        );

      default:
        return this.photoService.thumbnailById(id, unionId).pipe(
          catchError(err => {
            this.alertService.error(err, { autoClose: 30000 });
            return throwError(() => err);
          }),
        );
    }
  }
}
